// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3CLLG","content":"styles_content__naeNk","tableWrap":"styles_tableWrap__2GpFC"};